<template>
  <div class="section" id="whyus">
    <div class="left">
      <div class="cover"></div>
    </div>
    <div class="right">
      <div class="right_wrap">
        <div class="title">Why are we different</div>
        <div class="listing">
          <div class="item">
            <div class="number">1</div>
            <div class="content">
              Experience live, cross-team collaboration.
            </div>
          </div>
          <div class="item">
            <div class="number">2</div>
            <div class="content">
              Build real-world projects for your portfolio.
            </div>
          </div>
          <div class="item">
            <div class="number">3</div>
            <div class="content">Learn online from anywhere in the world.</div>
          </div>
          <div class="item">
            <div class="number">4</div>
            <div class="content">
              Prep for interviews with career coaches and mentors.
            </div>
          </div>
          <div class="item">
            <div class="number">5</div>
            <div class="content">
              Connect with hiring managers in our network.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {},
  },
};
</script>
<style>
.section#whyus {
  display: flex;
  padding: 1rem 2.5rem;
  padding-left: 0rem;
  min-height: calc(100vh - 75px);
}

.section#whyus .left {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.section#whyus .left .cover {
  width: 100%;
  background-image: url("./cover_2.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  height: 400px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}
.section#whyus .right {
  width: 100%;
  display: flex;
  align-items: center;

  justify-content: center;
}
.section#whyus .right_wrap {
  padding: 0rem 5rem 0rem 5rem;
}
.section#whyus .right .title {
  font-size: 3rem;
  font-family: "Volkhov", serif;
  font-weight: 400;
  margin-bottom: 2rem;
}
.section#whyus .right .listing {
  width: 100%;
}
.section#whyus .right .listing .item {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
}
.section#whyus .right .listing .item .number {
  cursor: default;
  background-color: #ea3c49;
  color: #fff;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  margin-right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>